import React from 'react';
import PropTypes from 'prop-types';

const LabelWithPreferredName = ({ secondaryClientLabel, secondaryClient }) => {
  return (
    <div>
      {`${secondaryClientLabel}: ${secondaryClient.attr('firstName')} ${secondaryClient.attr('preferredName') !== secondaryClient.attr('firstName') ? `(${secondaryClient.attr('preferredName')})` : ''} ${secondaryClient.attr('lastName')}`}
    </div>
  );
};

LabelWithPreferredName.propTypes = {
  secondaryClientLabel: PropTypes.string.isRequired,
  secondaryClient: PropTypes.object.isRequired,
};

export default LabelWithPreferredName;
